"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const recoil_1 = require("recoil");
const settlementManageState_1 = require("./settlementManageState");
const react_i18next_1 = require("react-i18next");
const useMediaQuery_1 = __importDefault(require("@mui/material/useMediaQuery"));
const Tabs_1 = __importDefault(require("@mui/material/Tabs"));
const Tab_1 = __importDefault(require("@mui/material/Tab"));
function default_1() {
    const [tabValue, setTabValue] = (0, recoil_1.useRecoilState)(settlementManageState_1.settlementManageTabValueState);
    const setSettlementRewardSelect = (0, recoil_1.useSetRecoilState)(settlementManageState_1.settlementRewardSelectState);
    (0, react_1.useEffect)(() => {
        if (tabValue === 'settlementDetails')
            setSettlementRewardSelect('keep');
    }, [tabValue]);
    const maxWidth768 = (0, useMediaQuery_1.default)('(max-width:768px)');
    const { t } = (0, react_i18next_1.useTranslation)();
    return ((0, jsx_runtime_1.jsxs)(Tabs_1.default, Object.assign({ value: tabValue, onChange: (_, val) => setTabValue(val), variant: maxWidth768 ? 'fullWidth' : 'standard', sx: {
            '.MuiTabs-flexContainer': {
                columnGap: maxWidth768 ? '1px' : '8px',
                borderBottom: maxWidth768 ? 0 : '1px solid var(--gray-5)',
                bgcolor: maxWidth768 ? 'var(--gray-10)' : 'unset',
            },
            '.MuiTabs-indicator': { bgcolor: 'var(--gray-80)', top: maxWidth768 ? 0 : 'unset' },
            '.MuiTab-root': {
                height: maxWidth768 ? '48px' : '56px',
                p: '0 16px',
                borderBottom: maxWidth768 ? '1px solid var(--gray-10)' : 0,
                lineHeight: '24px',
                fontSize: '16px',
                color: 'var(--gray-30)',
                bgcolor: 'var(--white)',
            },
            '.Mui-selected': {
                borderBottom: 0,
                fontWeight: 'bold',
                color: 'var(--gray-80) !important',
            },
        } }, { children: [(0, jsx_runtime_1.jsx)(Tab_1.default, { value: "settlementDetails", label: t('정산 내역') }), (0, jsx_runtime_1.jsx)(Tab_1.default, { value: "expenseRecord", label: t('비용 기록') })] })));
}
exports.default = default_1;
